<div
  class="map__control-group"
  [ngClass]="{
    'map__hide-controls': isHidden,
    'map__expand-controls': !isHidden,
    'top-bar-down': layout.appbar?.mode !== 'collapsed' && !miniMap,
    'map__top-control-group': position === 'top',
    'map__mini-map-control-group': miniMap
  }"
>
  <div>
    <ng-content select="[topMapControls]"></ng-content>
    <ng-container *ngIf="zoomControls">
      <button
        type="button"
        mat-icon-button
        (click)="zoomIn()"
        [matTooltip]="'common.zoomIn' | t"
        matTooltipPosition="left"
      >
        <sn-icon>add</sn-icon>
      </button>
      <button
        type="button"
        mat-icon-button
        (click)="zoomOut()"
        [matTooltip]="'common.zoomOut' | t"
        matTooltipPosition="left"
      >
        <sn-icon>remove</sn-icon>
      </button>
    </ng-container>
    <ng-container *ngIf="styleControls">
      <button
        type="button"
        mat-icon-button
        class="style-button"
        [matMenuTriggerFor]="styleMenu"
        [matTooltip]="'map.tools.changeStyle' | t"
        matTooltipPosition="left"
      >
        <sn-icon fontIcon="fa-map" fontSet="fal"></sn-icon>
      </button>

      <mat-menu #styleMenu="matMenu">
        <button type="button" mat-menu-item (click)="setStyle('light')">
          <sn-icon fontIcon="fa-sun" fontSet="fal"></sn-icon>
          <span>{{ 'map.styles.light' | t }}</span>
        </button>
        <button type="button" mat-menu-item (click)="setStyle('dark')">
          <sn-icon fontIcon="fa-moon" fontSet="fal"></sn-icon>
          <span>{{ 'map.styles.dark' | t }}</span>
        </button>
        <button type="button" mat-menu-item (click)="setStyle('satellite')">
          <sn-icon fontIcon="fa-image" fontSet="fal"></sn-icon>
          <span>{{ 'map.styles.satellite' | t }}</span>
        </button>
      </mat-menu>
    </ng-container>
    <ng-container *ngIf="drawingControls?.active">
      <button
        type="button"
        mat-icon-button
        [matTooltip]="'map.tools.drawPolygon' | t"
        matTooltipPosition="left"
        *ngIf="drawingControls.polygon"
        (click)="drawPolygon()"
      >
        <sn-icon fontIcon="fa-draw-polygon" fontSet="fal"></sn-icon>
      </button>
      <button
        type="button"
        mat-icon-button
        [matTooltip]="
          drawingControls.holdShiftForCircle
            ? 'Draw Circle (Hold Shift to Activate)'
            : ' Draw Circle'
        "
        matTooltipPosition="left"
        *ngIf="drawingControls.circle"
        (click)="drawCircle(); $event.stopPropagation()"
      >
        <sn-icon fontIcon="fa-dot-circle" fontSet="fal"></sn-icon>
      </button>
      <button
        (click)="$event.preventDefault(); freehand()"
        mat-icon-button
        matTooltip="Draw on Map"
        matTooltipPosition="left"
        type="button"
        *ngIf="drawingControls.pen"
      >
        <sn-icon fontIcon="fa-pen-swirl" fontSet="fal"></sn-icon>
      </button>
      <button
        type="button"
        mat-icon-button
        matTooltip="Draw Rectangle"
        matTooltipPosition="left"
        *ngIf="drawingControls.rectangle"
        (click)="drawRectangle(); $event.stopPropagation()"
      >
        <sn-icon fontIcon="fa-draw-square" fontSet="fal"></sn-icon>
      </button>
    </ng-container>
    <div class="map__extra-options">
      <ng-content></ng-content>
    </div>
    <ng-container *ngIf="toggleControls">
      <button
        type="button"
        mat-icon-button
        (click)="toggleMapControls()"
        matTooltip="Hide Tools"
        matTooltipPosition="left"
      >
        <sn-icon fontIcon="fa-long-arrow-alt-right" fontSet="fal"></sn-icon>
      </button>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="toggleControls">
  <div
    matTooltip="Show Tools"
    matTooltipPosition="left"
    class="tab-container"
    (click)="toggleMapControls()"
    [ngClass]="{ 'show-tab': !tabHidden }"
  >
    <sn-icon fontSet="fal" fontIcon="fa-ellipsis-v-alt" class="tools-tab"></sn-icon>
  </div>
</ng-container>
